export default "__VITE_ASSET__D3T9SEc8__"